export default __webpack_public_path__ + "static/grouped-column-0cb1abe8ad01c7e8817e0b6a45c07c10.png";